import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import { useIntl } from 'react-intl';

import ScoutIcon from '@/assets/chatbot/scout-wave-transparent.png';
import { useBreakpointContext } from '@/components/common/BreakpointContext';

import { TChatbotButtonProps } from './ChatbotContainer';

const SearchPageButton = ({ handleOpen }: TChatbotButtonProps) => {
  const intl = useIntl();
  const { isAboveDesktop } = useBreakpointContext();

  return (
    <button onClick={handleOpen} className="whitespace-nowrap">
      <div className="relative flex flex-row items-center justify-start flex-shrink-0 p-2 bg-gray-800 rounded-full gap-3 h-[2.125rem] md:h-10">
        <div className="absolute bottom-0 left-[.24rem] md:left-[.5rem]">
          <Image
            src={ScoutIcon}
            width={isAboveDesktop ? 32 : 28}
            height={isAboveDesktop ? 32 : 28}
            alt="Scout icon"
          />
        </div>
        <div className="flex flex-row items-center pr-1 pl-7 gap-1 md:pl-10 md:pr-3">
          <Text
            className="leading-none text-white md:leading-tight"
            variant={
              isAboveDesktop ? ETextStyleVariant.MediumRegular : ETextStyleVariant.SmallRegular
            }>
            {intl.formatMessage({
              defaultMessage: 'Search with',
              id: 'sDwfFD',
            })}
          </Text>
          <Text
            className="leading-none text-white md:leading-tight"
            variant={isAboveDesktop ? ETextStyleVariant.MediumBold : ETextStyleVariant.SmallBold}>
            {intl.formatMessage({
              defaultMessage: 'Scout',
              id: 'BQ4DlU',
            })}
          </Text>
        </div>
      </div>
    </button>
  );
};

export default SearchPageButton;
